import { render, staticRenderFns } from "./Scrollarrow.vue?vue&type=template&id=37b9584a&scoped=true&"
import script from "./Scrollarrow.vue?vue&type=script&lang=js&"
export * from "./Scrollarrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b9584a",
  null
  
)

export default component.exports